import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

export default function SendResumesModal({ show, onClose, selectedResumes, clients = [], requirements = [], loadingRequirements = false,  onSend }) {
    const [selectedClient, setSelectedClient] = useState("");
    const [selectedRequirement, setSelectedRequirement] = useState("");
    const [filteredRequirements, setFilteredRequirements] = useState([]);

    console.log("clients:", clients);
    console.log("requirements:", requirements);
    useEffect(() => {
        if (selectedClient) {
            // 🔍 Filter requirements by client_id
            const filtered = requirements.filter(
                (req) => req.client_id === selectedClient
            );
            setFilteredRequirements(filtered);
            setSelectedRequirement(""); // reset on client change
        } else {
            setFilteredRequirements([]);
            setSelectedRequirement("");
        }
    }, [selectedClient, requirements]);

    const handleSend = () => {
        if (!selectedClient || !selectedRequirement) {
            toast.error("Please select both client and requirement");
            return;
        }

        onSend({
            resumes: selectedResumes,
            client: selectedClient,
            requirement: selectedRequirement,
        });

        onClose();
    };

    return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Selected Resumes</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Client Dropdown */}
        <div className="mb-3">
          <Form.Label>Client</Form.Label>
          <Form.Select
            value={selectedClient}
            onChange={(e) => setSelectedClient(e.target.value)}
          >
            <option value="">-- Select Client --</option>
            {clients.map((client) => (
              <option key={client.value} value={client.value}>
                {client.label}
              </option>
            ))}
          </Form.Select>
        </div>

        {/* Requirement Dropdown */}
        <div className="mb-3">
          <Form.Label>Requirement</Form.Label>
          {loadingRequirements ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner animation="border" size="sm" />
              <span>Loading requirements...</span>
            </div>
          ) : (
            <Form.Select
              value={selectedRequirement}
              onChange={(e) => setSelectedRequirement(e.target.value)}
              disabled={!selectedClient}
            >
              <option value="">-- Select Requirement --</option>
              {filteredRequirements.map((req) => (
                <option key={req.value} value={req.value}>
                  {req.label}
                </option>
              ))}
            </Form.Select>
          )}
        </div>

        {/* Selected Resumes */}
        <div className="mt-3">
          <strong>Selected Resumes:</strong>
          <ul>
            {selectedResumes.map((r) => (
              <li key={r._resume_id}>
                {r.resume_name} ({r.resume_email})
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSend}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
}